import React, { useCallback, useState } from 'react';

import { useCreateTemplateSectionMutation } from '@dashboard/generated/wp/platform';
import { PlaylistAddOutlined } from '@mui/icons-material';
import { Button, Stack, Tooltip } from '@mui/material';

import { alertError, alertSuccess } from '@waypoint/react/notifications';

import { useCurrentTemplateSections, useIsLayoutTab } from './hooks';
import SectionLabelDialog from './SectionLabelDialog';
import { CollapseExpandAllButton } from './SectionsStore';

export function SectionsToolbar() {
  const isLayoutTab = useIsLayoutTab();
  const [dialogOpen, setDialogOpen] = useState(false);
  const { refetch } = useCurrentTemplateSections();

  const [createTemplateSection, { loading: createTemplateSectionLoading }] = useCreateTemplateSectionMutation();

  const onCreateSection = useCallback(
    async (name: string) => {
      try {
        await createTemplateSection({ variables: { name } });
        await refetch();
        setDialogOpen(false);
        alertSuccess('Section created');
      } catch (e) {
        alertError('Failed to create section');
      }
    },
    [createTemplateSection, refetch]
  );

  const renderExpandCollapseButton = () => {
    return <CollapseExpandAllButton />;
  };

  const renderCreateSectionDialog = () => {
    if (!dialogOpen) {
      return null;
    }
    return (
      <SectionLabelDialog
        disabled={createTemplateSectionLoading}
        title="Add a section"
        submitLabel="Add section"
        onClose={() => setDialogOpen(false)}
        onSubmit={onCreateSection}
        initialValue=""
      />
    );
  };

  if (isLayoutTab) {
    return null;
  }
  return (
    <>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Tooltip title="Add a section to organize your templates">
          <Button
            startIcon={<PlaylistAddOutlined />}
            size="small"
            onClick={() => setDialogOpen(true)}
            variant="outlined"
          >
            Add section
          </Button>
        </Tooltip>
        {renderExpandCollapseButton()}
      </Stack>
      {renderCreateSectionDialog()}
    </>
  );
}
